<div class="row my-auto">
  <div class="col-120 d-flex justify-content-center">
    <div class="card auth w-100">
      <div class="card-body auth__body">
        <div class="text-center">
          <logo></logo>
          <p class="card-title mt-2 font-weight-bold">Restore</p>
        </div>
        <form [formGroup]="authForm" (ngSubmit)="onSubmit(authForm)">
          <div class="form-group">
            <label for="email" class="fs-12 font-weight-bold">E-mail:</label>
            <input id="email"
                   type="text" class="form-control"
                   name="login" placeholder="E-mail"
                   formControlName="email" validate popper>
          </div>
          <small><a routerLink="/login">Back to login</a></small>

          <div class="d-flex justify-content-center align-items-center mt-5">
            <button class="btn btn-primary" [disabled]="!submitEnabled" type="submit">
              <span [class.invisible]="!submitEnabled">Restore</span>
              <preloader *ngIf="!submitEnabled" [sm]="true" color="current" [gif]="false"></preloader>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
